module.exports = __webpack_public_path__ + "img/Grapefruit.e9a82fdb.svg";